<template>
  <div class="chart-container overflow-hidden relative h-full">
        <template v-if="chartName === 'LineChart'">
              <line-chart
                  v-if="!loadingStore.isLoading && !!data"
                  ref="chart"
                  :key="guid"
                  :guid="guid"
                  :chartdata="data"
                  :computed-options="computedOptions"
            />
        </template>
        <template v-else-if="chartName === 'PieChart'">
              <pie-chart
                  v-if="!loadingStore.isLoading && !!data"
                  ref="chart"
                  :key="guid"
                  :guid="guid"
                  :chartdata="data"
                  :computed-options="computedOptions"
            />
        </template>
        <template v-else-if="chartName === 'BarChart'">
            <bar-chart
                  v-if="!loadingStore.isLoading && !!data"
                  ref="chart"
                  :key="guid"
                  :guid="guid"
                  :chartdata="data"
                  :computed-options="computedOptions"
            />
        </template>
  </div>
</template>

<script>
import Chart from 'chart.js'

import LineChart from './chart-types/LineChart'
import BarChart from './chart-types/BarChart'
import PieChart from './chart-types/PieChart'
import {useLoadingStore} from "@/store/loading";
import {useReportStore} from "@/store/report";

export default {
      setup() {
        const loadingStore = useLoadingStore()
        const reportStore = useReportStore()

        return { loadingStore, reportStore }
      },
      name: 'ChartContainer',
      components: {
            LineChart,
            BarChart,
            PieChart
      },
      props: {
            data: {
                  type: Object,
                  default: null,
            },
            responsive: {
                  type: Boolean,
                  default: true
            },
            showLegend: {
                  type: Boolean,
                  default: true
            },
            legendPosition: {
                  type: String,
                  default: 'top'
            },
            indexAxis: {
                  type: String,
                  default: 'x'
            },
            guid: {
                  type: String,
                  required: true,
            },
            chartType: {
                  type: Number,
                  required: true,
            }
      },
      data(){
            return {
                  ro: null,
                  wrapper: {
                        width: 200,
                        height: 200,
                  },
            }
      },
      computed: {
            chartName(){
                  if(this.data && this.chartType ){
                        const id = this.chartType === 4 ? 2 : this.chartType;
                        return this.reportStore.allCharts.find(chart => chart.id === id).name.replace(/\s/g, '')
                  } else {
                        return null
                  }
            },
            // styles(){
            //       let styles = {
            //                   position: "relative",
            //                   margin: '0 auto',
            //                   width: `${this.wrapper.width}px`,
            //             }
            //       if(this.responsive){
            //             // styles.height = '100%';
            //             styles.height = `${this.wrapper.height}px`;
            //             styles.width = '100%';
            //       }
            //       return JSON.stringify(styles).replaceAll(',','; ').replaceAll('"','').replace('{','').replace('}','')
            // },
            computedOptions(){
                  let options = {
                        responsive: this.responsive,
                        showLegend: this.showLegend,
                        legendPosition: this.legendPosition,
                        indexAxis: this.indexAxis,
                  }
                  return options
            }
      },
      mounted(){
            if(this.responsive){
                  this.ro = new ResizeObserver(entries => {
                        if(entries[0].contentBoxSize) {
                              const contentBoxSize = Array.isArray(entries[0].contentBoxSize) ? entries[0].contentBoxSize[0] : entries[0].contentBoxSize,
                                    contentWidth = contentBoxSize.inlineSize,
                                    contentHeight = contentBoxSize.blockSize;
                              this.wrapper.width = contentWidth
                              this.wrapper.height = contentHeight
                        }
                  })

                  this.ro.observe(this.$el)
            }
      },
      beforeDestroy () {
            if(this.responsive) {
                  this.ro.unobserve(this.$el)
            }
      }
}
</script>
<style lang="sass">
.chart-container
      max-height: inherit
</style>